// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  background: #d8e9f0 !important;
  font-family: "Inter" !important;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.border-container {
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  font-family: "Inter" !important;
}

h2,
h4 {
  text-align: center;
}

.App {
  min-height: 95vh;
}

form {
  display: flex;
  flex-direction: column;
  width: 30%;
}

input,
textarea,
select {
  width: 100%;
  padding: 15px;
  margin: 5px 0 20px 0;
  font-family: "Inter" !important;
  border: 1px solid #c7c7c7;
  border-radius: 7px;
}

input:hover,
textarea:hover,
select:hover,
.unit-dropdown:hover,
.input-file:hover{
  background: #d8e9f0 !important;
}

textarea{
  resize: none;
}

.input-error {
  background: #f0ddd8;
  border: 2px solid #ff1f1f !important;
}

label {
  font-size: 12px;
  text-align: start;
}

input[type="radio"] {
  margin: 0;
  padding: 0;
}

input[type="file"] {
  font-family: "Inter" !important;
  display: none;
  padding: 0;
  margin: 0;
}

.icon-img {
  width: 20px;
  transition: all 0.2s ease;
  fill: #000;
}

.input-file:hover .icon-img {
  cursor: pointer;
  background-color: #d8e9f0;
}

.input-file {
  border: 1px solid #c7c7c7;
  border-radius: 7px;
  padding: 15px;
  margin: 5px 0 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

button {
  font-family: "Inter" !important;
  text-transform: capitalize !important;
}

button:hover {
  background: none;
}

.btn-contained,
.btn-outlined {
  margin: 20px 0 !important;
  color: #000 !important;
  border-radius: 12px !important;
  font-family: "Inter" !important;
  width: 190px;
}

.btn-contained {
  background: #a3c7ff !important;
  color: #000 !important;
  border-radius: 12px !important;
  border: none !important;
}

.btn-contained:hover {
  background: #1a71f6 !important;
  color: #fff !important;
}

.btn-outlined {
  border: 1px solid #a3c7ff !important;
}

.btn-outlined:hover {
  border: 1px solid #1a71f6 !important;
}

.btn-reject {
  border: 1px solid #eb2b0b !important;
  color: #eb2b0b !important;
}

.btn-reject:hover {
  border: 1px solid #eb2b0b !important;
  background: #eb2b0b !important;
  color: #fff !important;
}

a {
  text-decoration: none;
  color: #000;
  font-size: 16px;
}

a:hover {
  color: #1a71f6;
}

.dashboard-container {
  padding: 20px;
  margin: 20px 0;
  background: #ffffff;
  border-radius: 20px;
  min-height: max-content;
  font-family: "Inter" !important;
}

.data-grid {
  background: #f6f6f6;
  border-radius: 20px;
  box-shadow: 0px 0px 4px 0px #00000033;
}

.form-title {
  font-weight: bold !important;
  margin: 10px 0 !important;
}

.table-input,
.unit-dropdown {
  border: none !important;
  margin: 0px 0;
  text-align: center;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.preview-grid {
  border-bottom: 1px solid #000;
  border-left: 1px solid #000;
  padding: 10px 20px;
  font-size: 14px;
}

.error {
  color: red;
  display: flex;
  font-size: 12px;
  margin-top: -18px;
}

.btn-container {
  width: 50%;
  display: flex;
  justify-content: center;
  margin: auto;
}

.dashboard-btns {
  font-weight: 600 !important;
  font-size: 12px !important;
  color: #737373 !important;
  text-transform: capitalize !important;
  font-family: "Inter" !important;
  border: 1px solid #d8e9f0 !important;
  border-radius: 12px 12px 0 0 !important;
  padding: 10px 20px !important;
  min-width: 130px !important;
}

.active {
  background: #d9edffbf !important;
  border-radius: 12px 12px 0 0 !important;
  color: #1a71f6 !important;
}

.pending-btn {
  border-radius: 10px !important;
  background: #ffc53e !important;
  font-family: "Inter" !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  color: #000 !important;
  padding: 5px 30px !important;
}

.pdf-mode {
  width: 100%;
  overflow: visible !important;
}

.pdf-mode * {
  white-space: normal !important;
  overflow: visible !important;
}

.pdf-mode th:first-child,
.pdf-mode td:first-child {
  min-width: 100px !important;
  white-space: normal !important;   /* allow wrapping */
  word-break: break-word !important;
}

@media print {
  .pdf-container {
    width: 100vw !important; /* Force full width */
  }
  .page-break {
    page-break-after: always;
    break-after: page;
  }
}

.tender-info {
  border: 1px solid #c7c7c7;
  background: #d8e9f0;
  border-radius: 7px;
  position: relative;
  display: inline-block;
  width: 220px;
  height: 100px;
  font-weight: 900;
  font-size: 16px;
  display: flex;
  justify-content: end;
  align-items: end;
  padding: 10px;
  font-family: "Nunito";
}

.tender-title {
  background: #6e276d;
  border: 1px solid #c7c7c7;
  border-bottom-right-radius: 14px;
  position: absolute;
  top: -10%;
  left: -5%;
  width: 70%;
  padding: 10px;
  z-index: 5;
  font-weight: 500;
  font-size: 13px;
  color: #fff;
  font-family: "Nunito";
}

.tender-card {
  width: 250px;
  height: 150px;
  border-radius: 20px;
  padding: 10px 20px;
}

.table-title {
  font-weight: 700;
  font-size: 13px;
}

.table-title:hover {
  color: #1a71f6;
  cursor: pointer;
}

.popper {
  padding: 10px;
  left: -10% !important;
  top: 1% !important;
  position: relative;
}

.menu {
  display: flex;
  justify-content: space-around;
  width: 350px;
  font-size: 12px;
  font-weight: bold;
  background: #d8e9f0bf;
  border-radius: 28px;
  padding: 10px;
}

.menu-item {
  background: #a3c7ff !important;
  border-radius: 12px !important;
  padding: 5px 20px;
  font-size: 12px !important;
}

.menu-item:hover {
  background: #1a71f6 !important;
  color: #fff;
  cursor: pointer;
}

th {
  font-family: "Inter" !important;
  font-weight: bold !important;
}

td,
tr {
  font-family: "Inter" !important;
  font-size: 13px !important;
}

.ts-file {
  border-radius: 10px;
  background: #a3c7ff;
  width: 100%;
  text-align: center;
  height: fit-content;
  padding: 15px;
  margin: 5px 0 20px 0;
}

.ts-file:hover {
  background: #1a71f6;
  color: #fff;
}

.dropdown-item {
  font-size: 14px !important;
  font-family: "Inter" !important;
}

.progress-container {
  display: flex;
  width: 100%;
  height: 8px;
  border-radius: 5px;
  overflow: hidden;
  background-color: #ffffff;
}

.blue-bar {
  background-color: #1a71f6;
  border-radius: 5px;
}

.loading-div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  background-color: rgba(255, 255, 255, 0.2);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  overflow-y: hidden;
}

.uploading-div {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 20px 40px;
  border-radius: 8px;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 10px;
}

.accept-all{
  color: #1A71F6 !important;
  font-size: 12px !important;
  border: 1px solid #1A71F6 !important;
  border-radius: 8px !important;
  min-width: 130px !important;
  margin-right: 10px !important;
}

.reject-all{
  color: #EB2B0B !important;
  font-size: 12px !important;
  border: 1px solid #EB2B0B !important;
  border-radius: 8px !important;
  min-width: 130px !important;
}

.btn-view-doc{
  font-size: 12px !important;
  width: auto !important;
  margin: 0 0 10px 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;;EAEE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;;EAKE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,qCAAqC;EACrC,+BAA+B;EAC/B,oCAAoC;EACpC,uCAAuC;EACvC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;;EAEE,2BAA2B;EAC3B,8BAA8B,IAAI,mBAAmB;EACrD,iCAAiC;AACnC;;AAEA;EACE;IACE,uBAAuB,EAAE,qBAAqB;EAChD;EACA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;;EAEE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;AAC/B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap\");\n\nhtml,\nbody {\n  background: #d8e9f0 !important;\n  font-family: \"Inter\" !important;\n}\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.border-container {\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  font-family: \"Inter\" !important;\n}\n\nh2,\nh4 {\n  text-align: center;\n}\n\n.App {\n  min-height: 95vh;\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  width: 30%;\n}\n\ninput,\ntextarea,\nselect {\n  width: 100%;\n  padding: 15px;\n  margin: 5px 0 20px 0;\n  font-family: \"Inter\" !important;\n  border: 1px solid #c7c7c7;\n  border-radius: 7px;\n}\n\ninput:hover,\ntextarea:hover,\nselect:hover,\n.unit-dropdown:hover,\n.input-file:hover{\n  background: #d8e9f0 !important;\n}\n\ntextarea{\n  resize: none;\n}\n\n.input-error {\n  background: #f0ddd8;\n  border: 2px solid #ff1f1f !important;\n}\n\nlabel {\n  font-size: 12px;\n  text-align: start;\n}\n\ninput[type=\"radio\"] {\n  margin: 0;\n  padding: 0;\n}\n\ninput[type=\"file\"] {\n  font-family: \"Inter\" !important;\n  display: none;\n  padding: 0;\n  margin: 0;\n}\n\n.icon-img {\n  width: 20px;\n  transition: all 0.2s ease;\n  fill: #000;\n}\n\n.input-file:hover .icon-img {\n  cursor: pointer;\n  background-color: #d8e9f0;\n}\n\n.input-file {\n  border: 1px solid #c7c7c7;\n  border-radius: 7px;\n  padding: 15px;\n  margin: 5px 0 20px 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\nbutton {\n  font-family: \"Inter\" !important;\n  text-transform: capitalize !important;\n}\n\nbutton:hover {\n  background: none;\n}\n\n.btn-contained,\n.btn-outlined {\n  margin: 20px 0 !important;\n  color: #000 !important;\n  border-radius: 12px !important;\n  font-family: \"Inter\" !important;\n  width: 190px;\n}\n\n.btn-contained {\n  background: #a3c7ff !important;\n  color: #000 !important;\n  border-radius: 12px !important;\n  border: none !important;\n}\n\n.btn-contained:hover {\n  background: #1a71f6 !important;\n  color: #fff !important;\n}\n\n.btn-outlined {\n  border: 1px solid #a3c7ff !important;\n}\n\n.btn-outlined:hover {\n  border: 1px solid #1a71f6 !important;\n}\n\n.btn-reject {\n  border: 1px solid #eb2b0b !important;\n  color: #eb2b0b !important;\n}\n\n.btn-reject:hover {\n  border: 1px solid #eb2b0b !important;\n  background: #eb2b0b !important;\n  color: #fff !important;\n}\n\na {\n  text-decoration: none;\n  color: #000;\n  font-size: 16px;\n}\n\na:hover {\n  color: #1a71f6;\n}\n\n.dashboard-container {\n  padding: 20px;\n  margin: 20px 0;\n  background: #ffffff;\n  border-radius: 20px;\n  min-height: max-content;\n  font-family: \"Inter\" !important;\n}\n\n.data-grid {\n  background: #f6f6f6;\n  border-radius: 20px;\n  box-shadow: 0px 0px 4px 0px #00000033;\n}\n\n.form-title {\n  font-weight: bold !important;\n  margin: 10px 0 !important;\n}\n\n.table-input,\n.unit-dropdown {\n  border: none !important;\n  margin: 0px 0;\n  text-align: center;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n}\n\n.preview-grid {\n  border-bottom: 1px solid #000;\n  border-left: 1px solid #000;\n  padding: 10px 20px;\n  font-size: 14px;\n}\n\n.error {\n  color: red;\n  display: flex;\n  font-size: 12px;\n  margin-top: -18px;\n}\n\n.btn-container {\n  width: 50%;\n  display: flex;\n  justify-content: center;\n  margin: auto;\n}\n\n.dashboard-btns {\n  font-weight: 600 !important;\n  font-size: 12px !important;\n  color: #737373 !important;\n  text-transform: capitalize !important;\n  font-family: \"Inter\" !important;\n  border: 1px solid #d8e9f0 !important;\n  border-radius: 12px 12px 0 0 !important;\n  padding: 10px 20px !important;\n  min-width: 130px !important;\n}\n\n.active {\n  background: #d9edffbf !important;\n  border-radius: 12px 12px 0 0 !important;\n  color: #1a71f6 !important;\n}\n\n.pending-btn {\n  border-radius: 10px !important;\n  background: #ffc53e !important;\n  font-family: \"Inter\" !important;\n  font-weight: 600 !important;\n  font-size: 12px !important;\n  color: #000 !important;\n  padding: 5px 30px !important;\n}\n\n.pdf-mode {\n  width: 100%;\n  overflow: visible !important;\n}\n\n.pdf-mode * {\n  white-space: normal !important;\n  overflow: visible !important;\n}\n\n.pdf-mode th:first-child,\n.pdf-mode td:first-child {\n  min-width: 100px !important;\n  white-space: normal !important;   /* allow wrapping */\n  word-break: break-word !important;\n}\n\n@media print {\n  .pdf-container {\n    width: 100vw !important; /* Force full width */\n  }\n  .page-break {\n    page-break-after: always;\n    break-after: page;\n  }\n}\n\n.tender-info {\n  border: 1px solid #c7c7c7;\n  background: #d8e9f0;\n  border-radius: 7px;\n  position: relative;\n  display: inline-block;\n  width: 220px;\n  height: 100px;\n  font-weight: 900;\n  font-size: 16px;\n  display: flex;\n  justify-content: end;\n  align-items: end;\n  padding: 10px;\n  font-family: \"Nunito\";\n}\n\n.tender-title {\n  background: #6e276d;\n  border: 1px solid #c7c7c7;\n  border-bottom-right-radius: 14px;\n  position: absolute;\n  top: -10%;\n  left: -5%;\n  width: 70%;\n  padding: 10px;\n  z-index: 5;\n  font-weight: 500;\n  font-size: 13px;\n  color: #fff;\n  font-family: \"Nunito\";\n}\n\n.tender-card {\n  width: 250px;\n  height: 150px;\n  border-radius: 20px;\n  padding: 10px 20px;\n}\n\n.table-title {\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.table-title:hover {\n  color: #1a71f6;\n  cursor: pointer;\n}\n\n.popper {\n  padding: 10px;\n  left: -10% !important;\n  top: 1% !important;\n  position: relative;\n}\n\n.menu {\n  display: flex;\n  justify-content: space-around;\n  width: 350px;\n  font-size: 12px;\n  font-weight: bold;\n  background: #d8e9f0bf;\n  border-radius: 28px;\n  padding: 10px;\n}\n\n.menu-item {\n  background: #a3c7ff !important;\n  border-radius: 12px !important;\n  padding: 5px 20px;\n  font-size: 12px !important;\n}\n\n.menu-item:hover {\n  background: #1a71f6 !important;\n  color: #fff;\n  cursor: pointer;\n}\n\nth {\n  font-family: \"Inter\" !important;\n  font-weight: bold !important;\n}\n\ntd,\ntr {\n  font-family: \"Inter\" !important;\n  font-size: 13px !important;\n}\n\n.ts-file {\n  border-radius: 10px;\n  background: #a3c7ff;\n  width: 100%;\n  text-align: center;\n  height: fit-content;\n  padding: 15px;\n  margin: 5px 0 20px 0;\n}\n\n.ts-file:hover {\n  background: #1a71f6;\n  color: #fff;\n}\n\n.dropdown-item {\n  font-size: 14px !important;\n  font-family: \"Inter\" !important;\n}\n\n.progress-container {\n  display: flex;\n  width: 100%;\n  height: 8px;\n  border-radius: 5px;\n  overflow: hidden;\n  background-color: #ffffff;\n}\n\n.blue-bar {\n  background-color: #1a71f6;\n  border-radius: 5px;\n}\n\n.loading-div {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  min-height: 100%;\n  background-color: rgba(255, 255, 255, 0.2);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto;\n  overflow-y: hidden;\n}\n\n.uploading-div {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  padding: 20px 40px;\n  border-radius: 8px;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.accept-all{\n  color: #1A71F6 !important;\n  font-size: 12px !important;\n  border: 1px solid #1A71F6 !important;\n  border-radius: 8px !important;\n  min-width: 130px !important;\n  margin-right: 10px !important;\n}\n\n.reject-all{\n  color: #EB2B0B !important;\n  font-size: 12px !important;\n  border: 1px solid #EB2B0B !important;\n  border-radius: 8px !important;\n  min-width: 130px !important;\n}\n\n.btn-view-doc{\n  font-size: 12px !important;\n  width: auto !important;\n  margin: 0 0 10px 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
